@let entry = row();
@let item = display();

<app-tooltip-item-preview #preview [display]="item">
  <div preview-footer class="mt-2 type-muted text-center">
    @if (entry.trade.rumorId) {
      Buying this reveals where the rumor leads.
    } @else {
      {{
        isPartyBuying()
          ? 'This ' + merchantLabel() + ' is selling this item to you.'
          : 'This ' + merchantLabel() + ' is buying this item from you.'
      }}
    }
  </div>
</app-tooltip-item-preview>

<button
  appListRow
  [disabled]="entry.soldOut || entry.maxQuantity === 0 || hasEnoughGoldToBuy()"
  [tp]="item ? preview.template() : undefined"
  [tpPlacement]="'top'"
  (click)="$event.shiftKey || activate.emit(false)"
  (click.shift)="activate.emit(true)"
  appSfx="ui-click"
  [sfxTrigger]="['click', 'hover']"
>
  @if (item) {
    <div class="flex flex-col items-center gap-2 shrink-0">
      <app-slot-rarity-outline
        [entry]="item"
        [spritesheet]="item.spritesheet"
      ></app-slot-rarity-outline>
    </div>

    <div class="flex flex-col flex-1 min-w-0 gap-2">
      <span class="type-entity-name truncate text-{{ item.rarity }}">
        {{ item.name }}
      </span>

      <div class="flex items-center gap-2 flex-wrap">
        @if (!entry.soldOut) {
          <span
            class="badge badge-sm"
            [class.badge-success]="isPartyBuying()"
            [class.badge-warning]="!isPartyBuying()"
          >
            {{ isPartyBuying() ? 'Buy' : 'Sell' }}
          </span>
        }

        @if (entry.ownedQuantity > 0) {
          <span class="badge badge-sm badge-data">
            Owned: {{ entry.ownedQuantity | number }}
          </span>
        }

        @let remaining = entry.remaining ?? 0;

        @if (remaining > 0) {
          <span class="badge badge-sm badge-data">Stock: {{ remaining }}</span>
        }

        @if (entry.soldOut) {
          <span class="badge badge-error badge-sm">Sold out</span>
        }
      </div>
    </div>

    <div class="flex flex-col items-end gap-1 ml-auto mr-2 shrink-0">
      <app-currency-cost [type]="goldCoinItemId" [amount]="entry.price" />
      @if (entry.trade.tokenCost; as tokenCost) {
        <app-currency-cost [type]="traderTokenItemId" [amount]="tokenCost" />
      }
    </div>
  }
</button>
